<template>
  <div class="page flex-col">
    <img
      class="image_4"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPngcdda314e1acd1a34bdc59b58990099c11b2b5edf3156159e051c877d22e08726.png"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />